import React, { Component } from "react"
import { translate } from "react-translate"
import { Segment, Grid, Image, List, Icon } from "semantic-ui-react"
import Devis from "./Devis"
import _ from "lodash"

import "./BodyDevisFactures.css"

class BodyDevisFactures extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleCalculPrice(type) {
    var tabCopy = this.props.data

    var tabPrice = _.filter(tabCopy, x => x.type == type).map(x => x.price)
    var sum = _.sumBy(tabPrice)
    console.log("state :", sum)
    return sum
  }

  render() {
    let { t } = this.props
    const { data } = this.props
    console.log("state :", this.props.data)
    return (
      <Segment id="BodyDevisFacturesDiv">
        <Grid columns="equal">
          <Grid.Row>
            <Grid.Column mobile={16} computer={8} tablet={6}>
              <Segment id="labelDevis">
                {t("category_chantier")}
                <Icon id="exempleChantier" name="edit" />{" "}
              </Segment>
            </Grid.Column>
            <Grid.Column mobile={16}>
              <Segment id="labelDevis">
                {t("category_total_devisé")}{" "}
                <span className="somme">{t("somme_total_devisé")}</span>
              </Segment>
            </Grid.Column>
            <Grid.Column mobile={16}>
              <Segment id="labelDevis">
                {t("category_total_facture")}
                <span className="somme"> {t("somme_total_facture")}</span>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Column>
            {_.map(data, devisData => {
              return (
                <Devis
                  key={devisData.reference}
                  // callback handleRowDropdownChange
                  handleRowDropdownChange={(e, val) =>
                    this.props.handleRowDropdownChange(
                      devisData.reference,
                      e,
                      val
                    )
                  }
                  icons={devisData.type == "facture" ? "eur" : "list"}
                  reference={devisData.reference}
                  name={devisData.name}
                  adress={devisData.adress}
                  price={devisData.price}
                  date={devisData.date}
                  statut={devisData.statut}
                />
              )
            })}
          </Grid.Column>
        </Grid>
      </Segment>
    )
  }
}

export default translate("ProBodyDevisFactures")(BodyDevisFactures)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/BodyDevisEtFactures/BodyDevisFactures.js